import React, { useState } from "react";

import TagMeetingHeader from "../components/TagMeetingHeader";
import TagRegularizeMeetingForm from "../components/TagRegularizeMeetingForm";
import ThankYouComponent from "../components/ThankYouComponent";

import constant from "../utils/constants";

const TagMeetings = () => {
  const [showSuccess, setShowSuccess] = useState(false);

  return (
    <>
      <TagMeetingHeader headerName={"Tag meeting"} />
      {showSuccess ? (
        <ThankYouComponent message="Done! Your meeting is set for the day." />
      ) : (
        <TagRegularizeMeetingForm
          meetingName={constant.tag_meeting}
          setShowSuccess={setShowSuccess}
        />
      )}
    </>
  );
};

export default TagMeetings;
